export default __webpack_public_path__ + "static/media/bonus2.503c53ef.svg";